import { render } from "./Avatar.vue?vue&type=template&id=614d2a38"
import script from "./Avatar.vue?vue&type=script&setup=true&lang=js"
export * from "./Avatar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/sarahmarinoff/Sites/fc2025/wp-content/plugins/baytek-portal-helper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Avatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "614d2a38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('614d2a38', __exports__)) {
    console.log('reload')
    api.reload('614d2a38', __exports__)
  }
  
  module.hot.accept("./Avatar.vue?vue&type=template&id=614d2a38", () => {
    console.log('re-render')
    api.rerender('614d2a38', render)
  })

}


export default __exports__